type LoadingSpinnerProps = {
  size?: 'sm' | 'md' | 'lg'
  label?: string
}

export function LoadingSpinner({ size = 'md', label }: LoadingSpinnerProps) {
  return (
    <div className={`loading-spinner loading-spinner--${size}`} role="status">
      <span className="loading-spinner__ring" aria-hidden="true" />
      {label ? (
        <span className="loading-spinner__label">{label}</span>
      ) : (
        <span className="sr-only">読み込み中</span>
      )}
    </div>
  )
}
